export default {
  name: 'Acontainer',
  props: {
    boxShadow: { type: String, default: () => '0 2px 12px 0 rgb(0 0 0 / 10%)' },
    background: { type: String, default: () => '#ffffff' },
    borderRadius: { type: String, default: () => '4px' },
    padding: { type: String, default: () => '20px' },
    styles: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: () => false },
  },
  render() {
    return (
      <div
        class="a-container"
        v-loading={this.loading}
        style={{
          padding: this.padding,
          boxShadow: this.boxShadow,
          background: this.background,
          borderRadius: this.borderRadius,
          ...this.styles
        }}
      >
        {this.$slots.default}
      </div>
    );
  }
}